import { render } from "./AssetSubType.vue?vue&type=template&id=089d556c&scoped=true"
import script from "./AssetSubType.vue?vue&type=script&lang=js"
export * from "./AssetSubType.vue?vue&type=script&lang=js"

import "./AssetSubType.vue?vue&type=style&index=0&id=089d556c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089d556c"]])

export default __exports__